// extracted by mini-css-extract-plugin
export var ProjectThumb = "ProjectThumb-module--ProjectThumb--xikMx";
export var aniSpin = "ProjectThumb-module--ani-spin--pk-qf";
export var image = "ProjectThumb-module--image---GR2v";
export var image__ani = "ProjectThumb-module--image__ani---xpAb";
export var image__filter = "ProjectThumb-module--image__filter--7NA13";
export var image__hover = "ProjectThumb-module--image__hover--F7NfL";
export var image__inner = "ProjectThumb-module--image__inner--V5W4u";
export var image__overlay = "ProjectThumb-module--image__overlay--h0DEF";
export var text = "ProjectThumb-module--text--DD2zi";